interface EnvConfig {
  port: number;
  apiUrl: string;
  assetsUrl: string;
}

export type Env = 'development' | 'test';

function getApiUrl(): string {
  const currentHost = window.location.host;

  if (currentHost.includes('dev.fane.dev')) {
    return 'https://api.dev.fane.dev';
  } else if (currentHost.includes('app.fane.dev')) {
    return 'https://v1.fane.dev';
  }

  return `http://${currentHost.split(':')[0]}:4001`;
}

console.log(import.meta.env.VITE_ASSETS_URL, import.meta.env.MODE);

export const config: EnvConfig = {
  production: {
    port: Number(3000) || 3000,
    apiUrl: getApiUrl(),
    assetsUrl: String(import.meta.env.VITE_ASSETS_URL || '/'),
  },
  development: {
    port: Number(3000) || 3000,
    apiUrl: getApiUrl(),
    assetsUrl: String(import.meta.env.VITE_ASSETS_URL || '/'),
  },
  test: {
    port: Number(3000) || 3000,
    apiUrl: getApiUrl(),
    assetsUrl: String(import.meta.env.VITE_ASSETS_URL || '/'),
  },
}[import.meta.env.MODE as Env];
